
    import {Inject, Options, Vue} from 'vue-property-decorator';
    import {Getter} from 'vuex-class';
    import getters from '@/profile-creation-wizard/components/for-creation/store/getters';
    import type {ProfileCreationForm} from '@/profile-creation-wizard/components/for-creation/store';
    import HeadlineSelection from '@/profile-creation-wizard/components/for-creation/ui/1_headline/HeadlineSelection.vue';
    import HeadlineSide from '@/profile-creation-wizard/components/for-creation/ui/1_headline/HeadlineSide.vue';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import StepActions from '@/profile-creation-wizard/common/ui/step/StepActions.vue';
    import StepMobileHeader from '@/profile-creation-wizard/common/ui/step/StepMobileHeader.vue';
    import {CreationFormValidation} from '@/profile-creation-wizard/components/for-creation/ProfileCreationForm';
    import {TrackingRepository} from '@/common/repositories/track/TrackingRepository';
    import {StepNavigator} from '@/profile-creation-wizard/common/step/StepNavigator';

    @Options({
        components: {
            HeadlineSide,
            HeadlineSelection,
            StepActions,
            StepMobileHeader,
        },
    })
    export default class HeadlineStep extends Vue {
        @Inject({from: DI.creationFormValidation})
        creationFormValidation!: CreationFormValidation;
        @Inject({from: DI.trackingRepository})
        trackingRepository!: TrackingRepository;
        @Getter(getters.creationForm)
        creationForm!: ProfileCreationForm;
        progressPercentage = 0;

        stepName = 'headline';

        async created(): Promise<void> {
            await this.trackingRepository.track('headline-view-page-v2');
            const meta = this.$router.currentRoute.value.meta;
            this.progressPercentage = meta.progressPercentage || 0;
            this.stepNavigator = new StepNavigator(this.$router, undefined, meta.nextStep);
        }

        get hasValidFieldPart(): boolean {
            return this.creationFormValidation.isHeadlineValid(this.creationForm.headline);
        }

        goNext(): void {
            this.trackingRepository.track('headline-input-v2', {
                headline: this.creationForm.headline,
            });

            this.stepNavigator.next();
        }

        headlineKeypressEnter(): void {
            if (this.hasValidFieldPart) {
                this.goNext();
            }
        }
    }
